  export const NEWS_FEED_URL_DOMAIN_CONST = "https://api.rss2json.com"

  export  const AMZONS_S3_URL_DOMAIN_CONST = "https://mdms-iwmi.s3.ap-south-1.amazonaws.com"
